'PackingListsPdf'.output()
'PACKING LIST'.title()
'PackingList'.datatype({transient: true})

'Header'.section({pageHeading: true})
'orderId'.field({caption: "Order Number"})
'orderDate'.field({date: true})
'shipFromLocationName'.field({caption: 'Ship From Location'})
'shippingNameAndCompany'.field({caption: "Ship To"})
'shippingAddress'.field({caption: "Address"})
'shippingEmailAndPhone'.field({caption: "Contact"})
'notes'.field()

'Lines'.manifest()
'PackingListLine'.datatype({transient: true})
'packingList'.field({refersToParent: 'PackingList', hidden: true})
'soLine'.field({refersTo: 'SOLine', hidden: true})
'descriptionAndSKU'.field({width: 59, caption: 'Product'})
'quantityOrdered'.field({caption: 'Ordered', numeric: true})
'quantityRemainingToShip'.field({width: 20, caption: 'Remaining to Ship', numeric: true})
'quantityToPick'.field({caption: 'Qty to Pack', numeric: true})
'quantityPicked'.field({caption: 'Qty Packed'})


'PackingListsPdf'.getCasts(async output => {
  let c = await 'Configuration'.bringFirst()
  return await c.getPackingListCasts(output)
/*
  

  let soAndLocToPackingList = async (so, loc) => {
    let orderId = await so.toOrderId()
    let packingLists = await 'PackingList'.bring({orderId: orderId})
    for ( var i = 0; i < packingLists.length; i++ ) {
      let packingList = packingLists[i]
      if ( packingList.shipFromLocationName === loc.locationName )
        return packingList
    }
    return null
  }

  let createPackingList = async (so, loc) => {
    let res = await 'PackingList'.create()
    res.orderId = await so.toOrderId()
    res.shipFromLocationName = loc.locationName
    res.orderDate = so.orderDate
    res.shippingNameAndCompany = so.shippingNameAndCompany
    res.shippingAddress = so.shippingAddress
    res.shippingEmailAndPhone = so.shippingEmailAndPhone
    res.notes = so.notes
    return res
  }

  let addSOLineToPackingList = async (packingList, soLine) => {
    let packingListLine = await 'PackingListLine'.create({parentCast: packingList}, {packingList: packingList.reference()})
    packingListLine.soLine = soLine.reference()
    packingListLine.sequence = soLine.sequence
    packingListLine.descriptionAndSKU = soLine.descriptionAndSKU
    packingListLine.quantityOrdered = soLine.quantityOrdered
    packingListLine.quantityRemainingToShip = soLine.quantityRemainingToShip
    packingListLine.quantityToPick = soLine.quantityToPick
    packingListLine.quantityToMake = soLine.quantityToMake
  }

  let addSOLineToPackingLists = async soLine => {
    let so = await soLine.toSO()
    if ( so.include !== 'Yes' ) return
    let loc = await soLine.toShipFromLocation()
    let packingList = await soAndLocToPackingList(so, loc)
    if ( ! packingList )
      packingList = await createPackingList(so, loc)
    await addSOLineToPackingList(packingList, soLine)
  }

  let addSOToPackingLists = async so => {
    let lines = await so.getLines()
    for ( var i = 0; i < lines.length; i++ ) {
      let line = lines[i]
      await addSOLineToPackingLists(line)
    }
  }

  let createPackingLists = async () => {
    let orders = await 'orders.RecentOrActive'.bring()
    for ( var i = 0; i < orders.length; i++ ) {
      updateProgress((i / orders.length) * 0.5)
      let order = orders[i]
      if ( ! await order.isActive() ) continue
      let so = await order.toSO(); if ( ! so ) continue
      await addSOToPackingLists(so)
    }
  }

  let setFulfillStagesToPacking = async () => {
    let packingListLines = await 'PackingListLine'.bring()
    for ( var i = 0; i < packingListLines.length; i++ ) {
      updateProgress(0.5 + ((i / packingListLines.length) * 0.4))
      let packingListLine = packingListLines[i]
      let soLine = await packingListLine.referee('soLine')
      soLine.fulfillStage = 'Packing'
      let so = await soLine.toSO()
      so.fulfillStage = 'Packing'
    }
    await global.foreman.doSave()
  }

  let updateProgress = async (complete) => {
    await global.updateProgress(complete)
    await global.wait(1)
  }

  global.startProgress({message: 'Generating Packing Lists'})
  try {
    'PackingList'.clear()
    await createPackingLists()
    updateProgress(0.5)
    await setFulfillStagesToPacking()
    updateProgress(0.95)
    return await 'PackingList'.bring()
  } catch(e) {
    global.gApp.showMessage(e.message)
  } finally {
    global.stopProgress()
  }
*/
})


